import { SharingLink } from '../../api';
import { SortOrder } from '@myua/kit/dist/antd/table/interface';
import { Key } from 'react';

export type SharingLinkShape = {
  links: SharingLink[];
  loading: boolean;
  selectedIds: SharingLink['id'][];
  linkModal: LinkModal;
  searchQuery: string;
  sorter: { columnKey?: Key; order?: SortOrder };
  pagination: { current?: number; pageSize?: number; total?: number };
  // Фильтр по колонке Active; undefined — показывать все ссылки. Фильтрация серверная
  // (is_active уходит в API), пагинация и total считаются на бэке (MYUA-16466).
  isActiveFilter: boolean | undefined;
};

export type LinkModal = {
  visible: boolean;
  inProgress: boolean;
  link: SharingLink | undefined;
};

export enum ColumnKey {
  id = 'id',
  name = 'name',
  link = 'link',
  is_active = 'is_active',
  created_at = 'created_at',
  email = 'email',
}
